import { render, staticRenderFns } from "./reciboCotizacion.vue?vue&type=template&id=053e0a00"
import script from "./reciboCotizacion.vue?vue&type=script&lang=js"
export * from "./reciboCotizacion.vue?vue&type=script&lang=js"
import style1 from "./reciboCotizacion.vue?vue&type=style&index=1&id=053e0a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports